import { Category } from './olo.category';

export class OloMenu {
  imagepath: string; // The base path to be used in the construction of an image's full URL
  categories: Category[];
}
